const LOAD_DATA_APPLICANT_NOTES           = 'LOAD_DATA_APPLICANT_NOTES'
const LOAD_DATA_APPLICANT_NOTES_SUCCESS   = 'LOAD_DATA_APPLICANT_NOTES_SUCCESS'
const LOAD_DATA_APPLICANT_NOTES_FAILED    = 'LOAD_DATA_APPLICANT_NOTES_FAILED'
const UNMOUNT_DATA_APPLICANT_NOTES        = 'UNMOUNT_DATA_APPLICANT_NOTES'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobsApplicantNotesReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_APPLICANT_NOTES:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_APPLICANT_NOTES_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_APPLICANT_NOTES_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_APPLICANT_NOTES:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobsApplicantNotesReducer;